<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="531.4px"
    height="340.96px"
    viewBox="0 0 531.4 340.96"
    style="enable-background:new 0 0 531.4 340.96;"
    xml:space="preserve"
  >
    <defs />
    <path class="fliegen st0" d="M394.87,220.55c-5.36-50.03,20.53-100.17,20.53-100.17" />
    <g>
      <path
        class="st1"
        d="M113.46,69.4c1.84-1.19,3.16-2.06,4.5-2.89c1.8-1.12,2.47-2.62,2.2-4.79c-0.71-5.65,2.07-8.43,7.67-7.92
		c4.34,0.39,8.68,0.77,13.02,1.17c2.35,0.21,4.07,1.05,4.76,3.65c0.73,2.75,2.96,3.9,5.66,3.81c4.83-0.16,9.66-0.37,14.46-0.85
		c1.02-0.1,2.24-1.27,2.82-2.27c2.21-3.72,2.4-3.88,6.37-2.66c0.43,0.13,0.94,0.28,1.36,0.18c2.9-0.68,6.78-6.88,6.18-9.79
		c-0.64-3.09-0.15-3.92,2.89-4.62c5.22-1.2,10.39-1.82,15.71-0.22c1.32,0.4,3.4-0.26,4.6-1.15c5.63-4.21,9.37-4.44,14.88-0.33
		c2.68,2,5.27,1.79,8.27,0.65c2.37-0.89,5.08-0.84,7.59-1.42c4.66-1.06,9.31-2.2,13.92-3.44c3.73-1.01,7.37-2.39,11.12-3.31
		c5.1-1.26,10.08-0.25,13.91,3.15c6.37,5.65,12.53,3.82,18.84,0.42c1.47-0.79,3-1.87,3.92-3.21c0.86-1.25,1.63-3.29,1.16-4.5
		c-0.46-1.19-2.41-2.03-3.88-2.54c-1.19-0.42-2.63-0.07-3.95-0.15c-0.84-0.06-1.72-0.16-2.49-0.46c-5.37-2.13-6.32-5.78-2.23-9.77
		c2.48-2.42,5.64-4.14,8.27-6.42c1.43-1.24,2.68-2.88,3.48-4.58c0.97-2.05,2.28-3.08,4.5-3.28c2.34-0.22,4.65-0.65,6.97-1.02
		c2.21-0.35,4.39-0.18,5.38,2.08c1.26,2.89,3.5,4.01,6.34,4.54c2.48,0.46,4.39,1.32,4.21,4.55c-0.12,2.19,1.78,2.42,3.5,2.03
		c4.61-1.04,7.04,0.08,9.7,4.01c0.71,1.04,2.39,2.1,3.57,2.04c6.04-0.28,12.07-0.92,18.1-1.44c0.38-0.03,0.79-0.21,1.12-0.11
		c5.52,1.77,11.44,2.75,15.49,7.54c2.9,3.43,6.33,6,10.52,7.84c3.23,1.42,6.11,3.71,8.99,5.83c2.2,1.62,4.09,3.67,6.25,5.36
		c4.17,3.26,7.98,3.15,12.12-0.18c0.58-0.47,1.18-0.91,1.89-1.46c5.11,3.79,9.26,8.98,10.41,14.55c1.23,5.95,0.85,13-3.58,18.41
		c-4.02,4.9-8.38,9.52-12.57,14.29c-1.06,1.21-2.05,2.48-3.04,3.75c-2.97,3.82-2.76,7.69-0.74,11.96c1.51,3.18,2.64,6.65,3.26,10.11
		c0.88,4.89,1.91,6.25,6.73,7.2c2.13,0.42,4.18,1.23,6.54,1.94c0.96,0,2.5-0.39,3.72,0.07c5.45,2.01,10.74,2.09,16.16-0.17
		c1.84-0.77,3.62-0.41,5.87,0.48c3.41,1.34,4.35,3.35,4.91,6.29c0.09,0.45,0.33,0.91,0.63,1.26c4.6,5.56,9.03,11.28,13.88,16.6
		c4.11,4.5,9.48,5.43,15.41,4.2c6.56-1.37,12.62-3.78,18.1-7.65c0.3-0.21,0.65-0.45,0.81-0.76c2.9-5.64,8.27-8.27,13.48-11.08
		c2.09-1.13,3.78-0.68,5.12,1.34c2.15,3.23,4.43,6.37,6.53,9.64c1.57,2.44,1.17,4.44-0.95,6.29c-5.52,4.8-6.01,7.26-2.77,13.73
		c0.59,1.17,1.14,2.36,1.83,3.79c-0.69,0.17-1.19,0.34-1.71,0.4c-3.45,0.44-3.66,0.82-3.71,4.27c-0.03,1.76-0.43,3.56-0.93,5.26
		c-0.45,1.53-1.25,2.96-1.9,4.43c-2.98,6.75-1.87,9.71,4.72,13c1.11,0.55,2.96,1.58,2.88,2.2c-0.27,2.29-1.13,4.53-1.97,6.71
		c-0.12,0.32-1.38,0.39-2.07,0.28c-3.18-0.47-6.36-0.98-9.52-1.62c-0.96-0.2-2.33-0.64-2.65-1.35c-1.91-4.24-6.3-4.55-9.7-6.36
		c-2.05-1.09-4.47-1.48-6.52-2.56c-5.74-3.04-15.02,1.78-15.28,8.28c-0.24,6.05-0.11,12.13,0.12,18.18
		c0.18,4.76,1.95,6.26,6.67,6.72c1.46,0.14,2.87,0.69,4.31,1.05c-0.06,0.23-0.12,0.46-0.18,0.69c0.72-0.33,1.44-0.66,2.16-0.99
		c0.08,0.78,0.41,1.66,0.17,2.33c-0.5,1.41-1.29,2.73-1.99,4.07c-2.08,3.94-1.42,7.17,2.06,10.08c1.52,1.28,3.07,2.53,4.52,3.88
		c1.48,1.38,1.71,3.07,0.9,4.94c-2.41,5.51-9.79,10.21-15.58,10.12c-0.24-3.37-0.13-6.78-0.8-10.03c-0.71-3.43-2.78-6.03-6.21-7.64
		c-1.33-0.63-2.53-2.47-2.94-3.98c-1.5-5.49-1.63-5.58-6.69-3.08c-5.04,2.49-9.8,5.98-15.95,5.02c-1.31-0.21-2.63-0.36-3.93-0.57
		c-1.78-0.29-2.58,0.4-2.75,2.25c-0.55,5.84-0.7,5.92-6.52,5.94c-0.85,0-1.73-0.11-2.55,0.04c-6.9,1.29-10.79-2.79-13.95-7.94
		c-3.11-5.08-6.01-10.29-9.05-15.41c-0.47-0.8-1.09-1.64-1.85-2.11c-4.42-2.71-8.76-5.59-13.4-7.85c-4.14-2.02-8.09,0.87-7.99,5.51
		c0.03,1.67,0.43,3.39,0.93,5c2.05,6.58,3.05,13.24,2.34,20.17c-0.31,2.98,0.27,6.06-0.1,9.02c-0.55,4.47-3.39,7.85-6.05,11.32
		c-2.22,2.9-4.33,5.96-5.94,9.22c-2.7,5.46-5.67,10.44-11.58,13.08c-2.58,1.15-3.4,3.8-3.41,6.43c-0.02,5.59-0.17,11.21,0.45,16.74
		c0.34,3.05,1.81,6.12,3.37,8.84c2.33,4.06,2.3,6.03-1.15,9.19c-3.78,3.46-10.43,4.34-14.88,1.67c-0.9-0.54-1.67-2.36-1.49-3.41
		c0.39-2.3,1.41-4.5,2.22-6.72c1.97-5.44,0.98-8.49-3.84-11.63c-3.49-2.27-6.97-4.57-10.5-6.77c-1.7-1.06-2.3-2.29-1.6-4.27
		c0.67-1.87,1.11-3.82,1.55-5.75c0.66-2.93,0.04-4.28-2.84-4.77c-3.38-0.58-4.81-2.27-5.11-5.65c-0.31-3.51-1.62-4.76-5.25-4.56
		c-9.7,0.54-16.54-4.59-22.66-11.07c-3.05-3.23-5.84-6.74-8.37-10.38c-0.9-1.29-1.25-3.47-0.9-5.03c0.94-4.24,2.22-8.42,3.68-12.51
		c1.31-3.67,1.07-6.77-1.73-9.67c-1.23-1.27-2.02-2.95-3.02-4.44c-1.55-2.31-2.68-2.28-4.82-0.6c-2.65,2.07-5.42,4.07-8.37,5.65
		c-4.72,2.53-7.56,6.65-9.6,11.23c-2.4,5.39-6.18,8.85-11.66,10.86c-5.95,2.19-7.88,8.89-3.31,13.28c4.77,4.58,3.78,9.79,3.23,15.04
		c-0.36,3.52-3.64,4.35-6.48,5.08c-6.11,1.56-7.72,3.72-6.68,9.88c0.71,4.17-0.84,7.03-4.15,9.48c-2.76,2.05-5.35,4.43-7.67,6.97
		c-3.6,3.94-7.28,6.94-13.2,5.76c-3.11-0.62-6.42-0.29-9.64-0.34c-2.75-0.04-4.77-1.13-5.63-3.86c-0.75-2.35-2.44-3.46-4.75-3.94
		c-13.08-2.73-8.14-3.56-20.06,2.29c-3.44,1.69-7.26,2.72-10.99,3.73c-4.34,1.17-8.44,2.61-12.12,5.33
		c-4.3,3.18-9.2,4.81-14.64,4.51c-0.38-0.02-0.78-0.08-1.13,0.02c-5.2,1.5-7.21-1.57-9.93-5.48c-3.6-5.18-5.37-10.72-6.86-16.58
		c-0.64-2.53-2.32-4.15-4.9-5.07c-4.51-1.61-7.08-6-6.62-10.73c0.06-0.56,0.11-1.13,0.12-1.7c0.03-4.45-1.8-6.01-6.21-5.33
		c-3.87,0.59-4.7,0.18-4.51-3.68c0.12-2.51,1.24-5.02,2.14-7.44c0.38-1.01,1.43-1.75,2.06-2.69c3.65-5.42,3.59-7.53-0.3-12.75
		c-1.36-1.82-2.63-3.71-4.05-5.48c-1.35-1.68-2.84-3.25-4.42-5.03c0.83-0.67,1.53-1.23,2.51-2.02c-3.42-9.03-8.39-17.17-18.45-18.74
		c-9.24-1.44-18.63,0.18-26.45,6.39c-1.93,1.53-3.7,3.25-5.65,4.75c-2.78,2.13-5.9,3.23-9.48,3.26c-6.94,0.05-10.25,4.16-8.95,10.93
		c0.98,5.07,2.61,9.62,7.89,12c2.61,1.18,2.5,5.26-0.25,6.31c-6.92,2.63-12.73,6.98-18.79,11.04c-3.7,2.48-8,1.9-12.08,0.59
		c-1.28-0.41-3.39-5.42-3.12-7.18c0.38-2.4,2.37-2.68,4.25-3.06c2.13-0.44,4.3-0.75,6.39-1.31c1.96-0.53,3.43-1.94,2.56-3.99
		c-2.73-6.44,1.02-11.45,3.36-16.79c0.11-0.25,0.35-0.45,0.49-0.7c4.08-7.4,5.16-8.18-0.47-14.43c-3.78-4.2-3.39-7.02,0.24-11.29
		c0.67-0.79,1.37-1.57,2.06-2.35c3.14-3.56,3.08-4.73,0.54-8.68c-0.71-1.09-1.08-3.12-0.54-4.16c1.41-2.72,3.04-5.53,5.25-7.59
		c8.3-7.73,16.94-15.09,25.29-22.76c5.22-4.8,9.04-10.33,8.47-18.06c-0.27-3.65,0.17-7.38,0.57-11.04c0.27-2.47,1.47-4.15,4.51-3.83
		c4.87,0.5,8.66-1.71,12.11-5c2.1-2,4.61-3.61,7.06-5.2c2.84-1.84,3.79-3.75,3.14-7.17c-0.69-3.63-0.2-4.59,3-6.43
		c2.84-1.63,5.78-3.14,8.39-5.09c1.69-1.26,3.01-3.12,4.21-4.9c2.46-3.63,5.67-6.24,9.51-8.3c3.11-1.67,4.95-4.57,5.08-8.08
		c0.17-4.61,2.35-8.05,5.33-11.26c5.38-5.8,5-7.21-2.38-9.76C119.12,71.51,116.57,70.54,113.46,69.4z"
      />
      <path class="fliegen st0" d="M24.64,202.23c0,0,127.9-10.42,266.46,27.41" />
      <path class="fliegen st0" d="M299.24,34.47c0,0,87.61,21.7,123.93,46.71" />
      <path class="fliegen st0" d="M352.61,175.46c46.39-32.86,89.98-24.8,89.98-24.8" />
      <path class="fliegen st0" d="M126.5,77.89c0,0,128.43,14.37,225.44,97.44" />
      <path class="fliegen st0" d="M292.25,228.03c65.89-54.78,150.18-77.5,150.18-77.5" />
      <path class="fliegen st0" d="M395.17,190.1c0,0,37.24-15.33,64.03-21.89" />
      <path class="fliegen st0" d="M415.54,120.34c0,0,35.65-18.54,72.62-17.21" />
      <path class="fliegen st0" d="M394.73,190.31c0,0,45.5,0.76,66.61,13.96" />
      <path class="fliegen st0" d="M461.24,204c-6.67-34.69,4.36-99.57,4.36-99.57" />
      <line class="fliegen st0" x1="298.81" y1="34.43" x2="427.1" y2="61.93" />
      <path class="fliegen st0" d="M211.04,40.14c0,0,154.93,46.41,204.36,80.11" />
      <line class="fliegen st2" x1="0.17" y1="278.83" x2="2.59" y2="284.2" />
      <line class="fliegen st0" x1="0.17" y1="278.83" x2="19.03" y2="281.72" />
      <line class="fliegen st0" x1="0.17" y1="278.83" x2="20.87" y2="242.82" />
      <line class="fliegen st0" x1="0.17" y1="278.83" x2="24.4" y2="201.94" />
      <line class="fliegen st0" x1="0.17" y1="278.83" x2="27.11" y2="248.18" />
      <line class="fliegen st0" x1="1.91" y1="282.72" x2="19.03" y2="281.72" />
      <line class="fliegen st0" x1="19.03" y1="281.72" x2="27.11" y2="248.18" />
      <line class="fliegen st0" x1="19.03" y1="281.72" x2="36.51" y2="268.07" />
      <line class="fliegen st0" x1="19.03" y1="281.72" x2="99.22" y2="285.81" />
      <line class="fliegen st0" x1="19.03" y1="281.72" x2="130.02" y2="329.34" />
      <line class="fliegen st0" x1="20.87" y1="242.82" x2="24.4" y2="201.94" />
      <line class="fliegen st0" x1="20.87" y1="242.82" x2="27.11" y2="248.18" />
      <line class="fliegen st0" x1="20.87" y1="242.82" x2="52.05" y2="234.44" />
      <line class="fliegen st0" x1="20.87" y1="242.82" x2="52.05" y2="234.44" />
      <line class="fliegen st0" x1="24.4" y1="201.94" x2="52.05" y2="234.44" />
      <line class="fliegen st0" x1="24.4" y1="201.94" x2="90.16" y2="235.09" />
      <line class="fliegen st0" x1="24.4" y1="201.94" x2="112.21" y2="69.57" />
      <line class="fliegen st0" x1="24.4" y1="201.94" x2="126.51" y2="77.86" />
      <line class="fliegen st0" x1="27.11" y1="248.18" x2="36.51" y2="268.07" />
      <line class="fliegen st0" x1="27.11" y1="248.18" x2="52.05" y2="234.44" />
      <line class="fliegen st0" x1="36.51" y1="268.07" x2="52.05" y2="234.44" />
      <line class="fliegen st0" x1="36.51" y1="268.07" x2="90.16" y2="235.09" />
      <line class="fliegen st0" x1="36.51" y1="268.07" x2="99.22" y2="285.81" />
      <line class="fliegen st0" x1="52.05" y1="234.44" x2="90.16" y2="235.09" />
      <line class="fliegen st0" x1="90.16" y1="235.09" x2="99.22" y2="285.81" />
      <line class="fliegen st0" x1="90.16" y1="235.09" x2="126.51" y2="77.86" />
      <path class="fliegen st0" d="M90.16,235.09c0,0,77.2-9.06,162.37,28.69" />
      <line class="fliegen st0" x1="99.22" y1="285.81" x2="130.02" y2="329.34" />
      <line class="fliegen st0" x1="99.22" y1="285.81" x2="252.53" y2="263.78" />
      <line class="fliegen st0" x1="112.21" y1="69.57" x2="125.88" y2="53.63" />
      <line class="fliegen st0" x1="112.21" y1="69.57" x2="126.51" y2="77.86" />
      <line class="fliegen st0" x1="125.88" y1="53.63" x2="126.51" y2="77.86" />
      <line class="fliegen st0" x1="125.88" y1="53.63" x2="178.48" y2="55.31" />
      <line class="fliegen st0" x1="125.88" y1="53.63" x2="209.52" y2="38.5" />
      <line class="fliegen st0" x1="126.51" y1="77.86" x2="178.48" y2="55.31" />
      <path class="fliegen st0" d="M126.51,77.86c0,0,107.83,130,126.02,185.92" />
      <line class="fliegen st0" x1="130.02" y1="329.34" x2="227.31" y2="323.8" />
      <line class="fliegen st0" x1="130.02" y1="329.34" x2="252.53" y2="263.78" />
      <line class="fliegen st0" x1="130.02" y1="329.34" x2="358.03" y2="340.79" />
      <line class="fliegen st0" x1="178.48" y1="55.31" x2="209.52" y2="38.5" />
      <path class="fliegen st0" d="M178.48,55.31c0,0,62.67,143.47,74.05,208.47" />
      <path class="fliegen st0" d="M178.48,55.31c0,0,78.46,94.43,112.6,173.73" />
      <path class="fliegen st0" d="M209.52,38.5c0,0,50.71-16.86,76.89-16.53" />
      <path class="fliegen st0" d="M209.52,38.5c0,0,59.91,89.67,81.56,190.54" />
      <path class="fliegen st0" d="M209.52,38.5c0,0,66.63-10.21,89.41-4.08" />
      <line class="fliegen st0" x1="209.52" y1="38.5" x2="300.36" y2="4.42" />
      <line class="fliegen st0" x1="227.31" y1="323.8" x2="252.53" y2="263.78" />
      <line class="fliegen st0" x1="227.31" y1="323.8" x2="255.77" y2="290.84" />
      <line class="fliegen st0" x1="227.31" y1="323.8" x2="352.98" y2="338.11" />
      <path class="fliegen st0" d="M227.31,323.8c0,0,62.81-10.17,130.72,16.99" />
      <line class="fliegen st0" x1="252.53" y1="263.78" x2="255.77" y2="290.84" />
      <line class="fliegen st0" x1="252.53" y1="263.78" x2="291.08" y2="229.04" />
      <line class="fliegen st0" x1="252.53" y1="263.78" x2="294.35" y2="261.36" />
      <line class="fliegen st0" x1="255.77" y1="290.84" x2="294.35" y2="261.36" />
      <path class="fliegen st0" d="M255.77,290.84c0,0,44.09-10.86,75.63-4" />
      <line class="fliegen st0" x1="255.77" y1="290.84" x2="352.98" y2="338.11" />
      <line class="fliegen st0" x1="286.41" y1="21.97" x2="298.93" y2="34.42" />
      <line class="fliegen st0" x1="286.41" y1="21.97" x2="300.36" y2="4.42" />
      <line class="fliegen st0" x1="286.41" y1="21.97" x2="301.43" y2="29.22" />
      <line class="fliegen st0" x1="291.08" y1="229.04" x2="294.35" y2="261.36" />
      <line class="fliegen st0" x1="291.08" y1="229.04" x2="294.78" y2="233.53" />
      <path class="fliegen st0" d="M291.08,229.04c21.65-90.98,7.85-194.62,7.85-194.62" />
      <path class="fliegen st0" d="M291.08,229.04c0,0,49.98-24.6,103.33-8.31" />
      <line class="fliegen st0" x1="291.08" y1="229.04" x2="415.48" y2="120.16" />
      <line class="fliegen st0" x1="294.35" y1="261.36" x2="294.78" y2="233.53" />
      <line class="fliegen st0" x1="294.35" y1="261.36" x2="331.41" y2="286.84" />
      <line class="fliegen st0" x1="294.78" y1="233.53" x2="331.41" y2="286.84" />
      <path class="fliegen st0" d="M294.78,233.53c0,0,60.06-19.94,99.63-12.79" />
      <line class="fliegen st0" x1="298.93" y1="34.42" x2="301.43" y2="29.22" />
      <path class="fliegen st0" d="M298.93,34.42c0,0,82.53,46.67,116.55,85.73" />
      <line class="fliegen st0" x1="298.93" y1="34.42" x2="429.35" y2="51.81" />
      <line class="fliegen st0" x1="300.36" y1="4.42" x2="301.43" y2="29.22" />
      <line class="fliegen st0" x1="300.36" y1="4.42" x2="325.57" y2="6.86" />
      <path class="fliegen st0" d="M301.43,29.22c0,0,9.31-18.23,24.14-22.35" />
      <line class="fliegen st0" x1="325.57" y1="6.86" x2="429.35" y2="51.81" />
      <line class="fliegen st0" x1="331.41" y1="286.84" x2="352.98" y2="338.11" />
      <line class="fliegen st0" x1="331.41" y1="286.84" x2="367.42" y2="321.83" />
      <path class="fliegen st0" d="M331.41,286.84c17.73-42.98,63-66.11,63-66.11" />
      <line class="fliegen st0" x1="352.98" y1="338.11" x2="358.03" y2="340.79" />
      <line class="fliegen st0" x1="352.98" y1="338.11" x2="367.42" y2="321.83" />
      <line class="fliegen st0" x1="358.03" y1="340.79" x2="367.42" y2="321.83" />
      <line class="fliegen st0" x1="358.03" y1="340.79" x2="369.12" y2="337.71" />
      <line class="fliegen st0" x1="367.42" y1="321.83" x2="369.12" y2="337.71" />
      <line class="fliegen st0" x1="367.42" y1="321.83" x2="394.41" y2="220.74" />
      <line class="fliegen st0" x1="367.42" y1="321.83" x2="432.21" y2="254.86" />
      <line class="fliegen st0" x1="369.12" y1="337.71" x2="432.21" y2="254.86" />
      <line class="fliegen st0" x1="369.12" y1="337.71" x2="489.12" y2="267.12" />
      <line class="fliegen st0" x1="394.41" y1="220.74" x2="432.21" y2="254.86" />
      <line class="fliegen st0" x1="394.41" y1="220.74" x2="472.41" y2="240.99" />
      <line class="fliegen st0" x1="394.41" y1="220.74" x2="472.41" y2="240.99" />
      <line class="fliegen st0" x1="394.41" y1="220.74" x2="483.92" y2="224.7" />
      <line class="fliegen st0" x1="394.41" y1="220.74" x2="489.39" y2="197.29" />
      <line class="fliegen st0" x1="415.48" y1="120.16" x2="429.35" y2="51.81" />
      <path class="fliegen st0" d="M415.48,120.16c0,0,56.89,64.64,73.91,77.13" />
      <path class="fliegen st0" d="M415.48,120.16c0,0,46.85,8.54,83.8,33.11" />
      <line class="fliegen st0" x1="429.35" y1="51.81" x2="499.28" y2="153.26" />
      <line class="fliegen st0" x1="429.35" y1="51.81" x2="528.14" y2="137.49" />
      <line class="fliegen st0" x1="432.21" y1="254.86" x2="472.41" y2="240.99" />
      <line class="fliegen st0" x1="432.21" y1="254.86" x2="489.12" y2="267.12" />
      <line class="fliegen st0" x1="472.41" y1="240.99" x2="483.92" y2="224.7" />
      <line class="fliegen st0" x1="472.41" y1="240.99" x2="489.12" y2="267.12" />
      <line class="fliegen st0" x1="472.41" y1="240.99" x2="497.06" y2="231.48" />
      <line class="fliegen st0" x1="472.41" y1="240.99" x2="502.86" y2="256.81" />
      <line class="fliegen st0" x1="483.92" y1="224.7" x2="489.39" y2="197.29" />
      <line class="fliegen st0" x1="483.92" y1="224.7" x2="497.06" y2="231.48" />
      <line class="fliegen st0" x1="489.12" y1="267.12" x2="502.86" y2="256.81" />
      <line class="fliegen st0" x1="489.39" y1="197.29" x2="497.06" y2="231.48" />
      <path class="fliegen st0" d="M489.39,197.29c-0.38-18.04,9.89-44.03,9.89-44.03" />
      <line class="fliegen st0" x1="489.39" y1="197.29" x2="521.36" y2="207.72" />
      <line class="fliegen st0" x1="489.39" y1="197.29" x2="522.96" y2="192.75" />
      <line class="fliegen st0" x1="497.06" y1="231.48" x2="502.86" y2="256.81" />
      <line class="fliegen st0" x1="497.06" y1="231.48" x2="521.36" y2="207.72" />
      <line class="fliegen st0" x1="499.28" y1="153.26" x2="522.96" y2="192.75" />
      <line class="fliegen st0" x1="499.28" y1="153.26" x2="528.14" y2="137.49" />
      <line class="fliegen st0" x1="502.86" y1="256.81" x2="521.36" y2="207.72" />
      <line class="fliegen st0" x1="502.86" y1="256.81" x2="531.24" y2="205.9" />
      <line class="fliegen st0" x1="521.36" y1="207.72" x2="522.96" y2="192.75" />
      <line class="fliegen st0" x1="521.36" y1="207.72" x2="531.24" y2="205.9" />
      <line class="fliegen st0" x1="522.96" y1="192.75" x2="528.14" y2="137.49" />
      <line class="fliegen st0" x1="522.96" y1="192.75" x2="531.24" y2="205.9" />
      <line class="fliegen st0" x1="528.14" y1="137.49" x2="531.24" y2="205.9" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'AnimatedSwissMap',
};
</script>

<style lang="scss">
/**
 * svg styles
 */
.st0 {
  fill: none;
  stroke: #020203;
  stroke-width: 0.5;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st1 {
  fill: none;
  stroke: #e30613;
  stroke-width: 1.5;
  stroke-miterlimit: 10;
}
.st2 {
  fill: none;
  stroke: #020203;
  stroke-width: 0.75;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.st3 {
  fill: none;
  stroke: #020203;
  stroke-width: 0.5;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 3, 3;
}

/**
 * Animation
 */
.fliegen {
  stroke: #397c8b;
  fill: transparent;
  stroke-width: 0.3px;
  stroke-dasharray: 500px;
  animation: movein 10s ease-in;
  animation-fill-mode: forwards;
}
@keyframes movein {
  0% {
    stroke-dashoffset: 1000px;
  }
  100% {
    stroke-dashoffset: 1px;
  }
}
</style>
